import { Box, Grid, useTheme } from "@mui/material";
import { Button, IconCopy, useToast } from "@veneer/core";
import "@veneer/styles/typography/typography.css";
import PropTypes from "prop-types";
import React from "react";
import ShimmerLoader from "../shimmerLoader/ShimmerLoader";
import InputTooltip from "./form/InputTooltip";

const GenericPageHeader = ({
  loading,
  title,
  subtitle,
  tagComponent,
  tooltipText,
  children,
  copyOptions,
  loadingTitle,
}) => {
  const { addToast } = useToast();
  const { palette } = useTheme();

  const copyValue = (value) => {
    navigator.clipboard.writeText(value);
    const message = copyOptions?.message
      ? copyOptions.message
      : "Copied to the clipboard";

    addToast({
      text: message,
      type: "positive",
      timeout: 6,
      id: Date.now(),
    });
  };

  if (loading || loadingTitle) {
    return (
      <div>
        <ShimmerLoader type="largeText" width="150px" />
        {loading && <ShimmerLoader type="text" width="300px" />}
      </div>
    );
  }

  const shouldShowCopyButton = !!copyOptions && copyOptions.allowed;
  const maxWidth = { width: "100%" };
  return (
    <Box>
      <Grid
        container
        alignItems="flex-start"
        justifyContent="space-between"
        flexWrap="nowrap"
        sx={{ ...maxWidth, marginBottom: "12px", gap: "12px" }}
      >
        <Grid item sx={{ flexGrow: 1 }}>
          <Grid container alignItems="center" sx={maxWidth}>
            <Grid item sx={maxWidth}>
              <h3 style={{ ...maxWidth, wordBreak: "break-word" }}>{title}</h3>
            </Grid>
          </Grid>
        </Grid>

        {!!children && (
          <Grid item sx={{ flexShrink: 0 }}>
            {children}
          </Grid>
        )}
      </Grid>
      {!!subtitle && (
        <Grid container>
          <Grid item alignSelf="center">
            <span
              style={{
                display: "block",
                margin: 0,
                padding: 0,
                color: shouldShowCopyButton ? palette.primary.main : undefined,
              }}
            >
              {subtitle}
            </span>
          </Grid>

          {shouldShowCopyButton && (
            <Grid item ml={0.5}>
              <Button
                leadingIcon={<IconCopy />}
                onClick={() => copyValue(copyOptions.value || subtitle)}
                small
                appearance="ghost"
              />
            </Grid>
          )}
        </Grid>
      )}
      {!!tagComponent && (
        <Grid
          item
          sx={{ display: "flex", alignItems: "center", marginTop: "4px" }}
        >
          {tagComponent}
          {tooltipText && <InputTooltip tooltip={tooltipText} />}
        </Grid>
      )}
    </Box>
  );
};

GenericPageHeader.propTypes = {
  loading: PropTypes.bool,
  loadingTitle: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  tagComponent: PropTypes.node,
  children: PropTypes.node,
  copyOptions: PropTypes.shape({
    allowed: PropTypes.bool,
    message: PropTypes.string,
    btnColor: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default GenericPageHeader;
